import { Montserrat, Open_Sans } from 'next/font/google';
import type { AppFonts } from '../../entries/AppFonts';

const textBody = Open_Sans({
  subsets: ['latin'],
  weight: ['400', '500', '600', '700', '800'],
  style: ['normal', 'italic'],
  variable: '--font-family-text-body',
});

const heading = Montserrat({
  subsets: ['latin'],
  weight: ['400', '500', '600', '700'],
  variable: '--font-family-heading',
});

export function getDefaultFonts(): AppFonts {
  return {
    textBody,
    heading,
    className: `${textBody.variable} ${heading.variable}`,
  };
}
